import { paginationStyles } from "@insite/content-library/Widgets/OrderApprovalList/OrderApprovalListPagination";
import { getMgbwPaginationOverrides } from "@tSurya/Common/Utilities/mgbwPaginationOverrides";

paginationStyles.pagination = getMgbwPaginationOverrides();
